import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import PhotoSlider from "../Components/PhotoSlider";
import FlexContainer from "../Components/FlexContainer";
import "./home.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import TestimonialsSlider from "./TestimonialsSlider";

function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

  const navigate = useNavigate();

  function handleWindowSizeChange() {
    setIsMobile(window.innerWidth <= 1200);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <Wrapper>
      <TopImage>
        <HeroOverlay />
        <AccentGlow />
        <AccentGlowSecondary />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            position: "relative",
            zIndex: 2,
            padding: "0 20px",
            textAlign: "center",
          }}
        >
          <BioTitle style={{ marginBottom: 10 }}>
            Storytelling for the free-spirited and deeply in love
          </BioTitle>
          <HeroSubhead>
            Editorial polish with a boho heart—crafted to feel artful,
            effortless, and undeniably you.
          </HeroSubhead>
          <HeroKicker>Colorado + beyond</HeroKicker>
        </motion.div>
      </TopImage>
      <WhiteShort>
        <Column style={{ width: "100%" }}>
          <Column style={{ width: "100%", textAlign: "center" }}>
            <div
              style={{
                padding: "5px",
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                border: "1px solid #333",
                margin: "0px auto 0px auto",
              }}
            >
              <img
                alt="logo"
                src={
                  "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/logo.png"
                }
                style={{
                  borderRadius: "50%",
                  margin: "0px auto 0px auto",
                  width: "100px",
                  border: "1px solid black",
                  marginLeft: -0.5,
                  marginTop: -0.5,
                }}
              />
            </div>
            <TestimonialsSlider />
          </Column>
        </Column>
      </WhiteShort>
      <Info>
        <FlexContainer
          styles={{
            justifyContent: "space-between",
            width: "100vw",
            paddingTop: isMobile ? 0 : 50,
            textAlign: "center",
          }}
        >
          {!isMobile && (
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
              style={{
                width: "35vw",
                margin: "auto 0px auto 150px",
                position: "relative",
              }}
            >
              <GradientBar />
              <InfoTitle>The Rainbow Trout Reverie Promise...</InfoTitle>
              <p>
                Every collection is designed to feel like a sun-soaked
                adventure—intentional posing blended with space for the
                effortless, unscripted magic. I scout locations, curate
                palettes, and guide you with gentle direction so your gallery
                looks elevated yet true to you. Expect heirloom-worthy images
                with a relaxed, boho spirit and a marketing polish that makes
                your story impossible to forget.
              </p>
            </motion.div>
          )}
          {isMobile && (
            <div
              style={{
                justifyContent: "center",
                textAlign: "center",
                padding: 20,
              }}
            >
              <InfoTitle>The Rainbow Trout Reverie Promise...</InfoTitle>
            </div>
          )}
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
            style={{ marginRight: isMobile ? "-18.5vw" : 100 }}
          >
            <PhotoSlider />
          </motion.div>
          {isMobile && (
            <div
              style={{
                justifyContent: "center",
                textAlign: "center",
                padding: 20,
              }}
            >
              <GradientBar mobile />
              <p>
                Every collection is designed to feel like a sun-soaked
                adventure—intentional posing blended with space for the
                effortless, unscripted magic. I scout locations, curate
                palettes, and guide you with gentle direction so your gallery
                looks elevated yet true to you. Expect heirloom-worthy images
                with a relaxed, boho spirit and a marketing polish that makes
                your story impossible to forget.
              </p>
            </div>
          )}
        </FlexContainer>
        <Button
          onClick={() => {
            navigate("/portfolio");
            window.scrollTo(0, 0);
          }}
        >
          Check Out My Portfolio
        </Button>
      </Info>
      <BioImage>
        <FlexContainer
          styles={{ justifyContent: "space-between", width: "100vw" }}
        >
          {isMobile ? (
            <div style={{ width: "100%" }}>
              <Column style={{ margin: " 0px auto", width: "fit-content" }}>
                <div>
                  <img
                    alt="lex"
                    src={
                      "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/lex3.webp"
                    }
                    style={{
                      width: "80vw",
                      borderRadius: "10%",
                      outline: "1px solid white",
                      outlineOffset: "5px",
                    }}
                  />
                </div>
                <div
                  style={{
                    padding: "5px",
                    width: "150px",
                    borderRadius: "10%",
                    marginLeft: 220,
                    marginTop: -150,
                  }}
                >
                  <img
                    alt="lex"
                    src={
                      "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/lex1.webp"
                    }
                    style={{
                      width: "150px",
                      borderRadius: "10%",
                      outline: "1px solid white",
                      outlineOffset: "5px",
                    }}
                  />
                </div>
              </Column>
              <Column
                style={{
                  width: "80vw",
                  margin: " 0px auto ",
                  textAlign: "center",
                }}
              >
                <BioTitle>Hi, I’m Lexi!</BioTitle>
                <p style={{ color: "#fff", marginTop: -20 }}>
                  I’m a Colorado photographer with a soft spot for golden-hour
                  hikes, candid laughter, and details that feel like you. My
                  background in branding means I blend editorial intention with
                  warm, lived-in moments—crafting galleries that feel elevated,
                  soulful, and ready to frame or share.
                </p>
              </Column>
            </div>
          ) : (
            <>
              <motion.div
                initial={{ opacity: 0, x: 100 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
                style={{ width: "30vw", margin: "auto" }}
              >
                <div
                  style={{
                    padding: "5px",
                    width: "300px",
                    borderRadius: "50%",
                    marginLeft: 80,
                  }}
                >
                  <img
                    alt="lex"
                    src={
                      "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/lex3.webp"
                    }
                    style={{
                      width: "300px",
                      borderRadius: "10%",
                      marginLeft: 0,
                      outline: "1px solid white",
                      outlineOffset: "5px",
                    }}
                  />
                </div>
                <div
                  style={{
                    padding: "5px",
                    width: "150px",
                    borderRadius: "50%",
                    marginTop: -150,
                    marginLeft: 300,
                  }}
                >
                  <img
                    alt="lex"
                    src={
                      "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/lex1.webp"
                    }
                    style={{
                      width: "150px",
                      borderRadius: "10%",
                      outline: "1px solid white",
                      outlineOffset: "5px",
                    }}
                  />
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
                style={{ width: "30vw", margin: "auto" }}
              >
                <BioTitle>Hi, I’m Lexi!</BioTitle>
                <p style={{ color: "#fff", marginTop: -20 }}>
                  I’m a Colorado photographer with a soft spot for golden-hour
                  hikes, candid laughter, and details that feel like you. My
                  background in branding means I blend editorial intention with
                  warm, lived-in moments—crafting galleries that feel elevated,
                  soulful, and ready to frame or share.
                </p>
              </motion.div>
            </>
          )}
        </FlexContainer>
        <Button
          onClick={() => {
            navigate("/about");
            window.scrollTo(0, 0);
          }}
        >
          Learn More About Me
        </Button>
      </BioImage>
    </Wrapper>
  );
}
export default Home;

const InfoTitle = styled.p`
  font-size: 2.1em;
  color: #ada98d;
  margin-top: 0px;
`;

const HeroKicker = styled.span`
  letter-spacing: 0.2em;
  text-transform: uppercase;
  font-size: 0.9em;
  color: #f4f0e6;
  background: rgba(0, 0, 0, 0.35);
  padding: 10px 16px;
  border-radius: 999px;
  margin-bottom: 15px;
`;

const HeroSubhead = styled.p`
  max-width: 620px;
  font-size: 1.1em;
  color: #f7f5ef;
  line-height: 1.6;
`;

const BioTitle = styled.p`
  font-size: 2.7em;
  font-weight: 300;
  color: #fff;
`;

const floaty = keyframes`
  from {
    transform: translateY(-6px) translateX(-8px);
  }
  to {
    transform: translateY(12px) translateX(8px);
  }
`;

// Create a Wrapper component that'll render a <section> tag with some styles
const Wrapper = styled.section`
  flex-direction: column;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  overflow-x: hidden;
`;

const TopImage = styled.section`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-image: url(${"https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/cover1.jpg"});
  background-size: cover; /* Adjust as needed */
  background-position: center; /* Adjust as needed */
  background-repeat: no-repeat; /* Adjust as needed */
  width: 100%; /* Example dimensions */
  height: 100vh; /* Example dimensions */
  width: 100%;
  overflow: hidden;
`;

const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
      120deg,
      rgba(15, 11, 7, 0.6),
      rgba(22, 18, 14, 0.4),
      rgba(11, 8, 6, 0.65)
    ),
    radial-gradient(
      circle at 20% 20%,
      rgba(255, 255, 255, 0.08),
      transparent 35%
    ),
    radial-gradient(
      circle at 80% 10%,
      rgba(255, 247, 236, 0.1),
      transparent 32%
    );
  z-index: 1;
`;

const AccentGlow = styled.div`
  position: absolute;
  width: 380px;
  height: 380px;
  background: radial-gradient(
    circle,
    rgba(255, 191, 158, 0.18),
    transparent 60%
  );
  filter: blur(50px);
  top: 8%;
  left: -4%;
  z-index: 0;
  animation: ${floaty} 16s ease-in-out infinite alternate;
`;

const AccentGlowSecondary = styled.div`
  position: absolute;
  width: 320px;
  height: 320px;
  background: radial-gradient(
    circle,
    rgba(173, 169, 141, 0.24),
    transparent 62%
  );
  filter: blur(55px);
  bottom: -6%;
  right: -4%;
  z-index: 0;
  animation: ${floaty} 14s ease-in-out infinite alternate-reverse;
`;

const GradientBar = styled.div`
  position: ${(props) => (props.mobile ? "relative" : "absolute")};
  left: ${(props) => (props.mobile ? "50%" : "-70px")};
  transform: ${(props) => (props.mobile ? "translateX(-50%)" : "none")};
  top: ${(props) => (props.mobile ? "-10px" : "-30px")};
  width: ${(props) => (props.mobile ? "120px" : "14px")};
  height: ${(props) => (props.mobile ? "4px" : "120px")};
  background: linear-gradient(180deg, #f1dec2, #ada98d);
  border-radius: 12px;
  opacity: 0.9;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
`;

const BioImage = styled.section`
  background-image: url(${"https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/bioBackground.webp"});
  background-size: cover; /* Adjust as needed */
  background-position: top; /* Adjust as needed */
  background-repeat: no-repeat; /* Adjust as needed */
  height: fit-content; /* Example dimensions */
  width: 100%;
  padding: 50px 0px;
  @media only screen and (min-width: 1200px) {
    flex-direction: column;
    display: flex;
    justify-content: space-around;
  }
`;

const Info = styled.section`
  flex-direction: column;
  display: flex;
  background: #fcfaf2;
  align-items: center;
  height: fit-content;
  padding-top: 30px;
  padding-bottom: 50px;
  width: 100%;
`;

const WhiteShort = styled.section`
  flex-direction: row;
  display: flex;
  justify-content: space-evenly;
  background: #fff;
  height: fit-content;
  flex-shrink: 0;
  flex-grow: 0;
  padding: 30px 0px 30px;
  width: 100%;
`;

const Column = styled.section`
  display: flex;
  flex-direction: column;
`;

const Button = styled.h1`
  font-size: 2em;
  font-weight: 300;
  width: 90%;
  color: #333;
  cursor: pointer;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 10px 5px 0px 5px;
  background-color: #fcfaf2;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  margin-bottom: 0px;
  text-align: center;
  @media only screen and (min-width: 1200px) {
    width: 400px;
  }
`;
